export default __webpack_public_path__ + "static/media/section-reime-verse.e30b5856.webp";